import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_ENABLE_VISION_FE_HELLOWORLD = createFcmConfig('enable_vision_fe_helloworld', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
